import React from 'react';
import PropTypes from 'prop-types';
import AzureAuthenticationContext from './azure-authentication-context';
import styles from '../login.scss';
import msLogo from '../../../../../app/assets/images/microsoft_assets/ms-logo.png';

const MicrosoftLogin = ({ onAuthenticated, onError }) => {
  const authenticationModule = new AzureAuthenticationContext();

  const returnedAccountInfo = (accountInfo, msal) => onAuthenticated(accountInfo, msal);

  const logIn = () => (
    authenticationModule.login('loginPopup', returnedAccountInfo, onError));

  return (
    <button className={styles.msBtnContainer} onClick={logIn}>
      <img className={styles.msBtnImg} src={msLogo} width={'38'} height={'38'} alt={''} />
      <span className={styles.msBtnText}>Sign In with Microsoft</span>
    </button>
  );
};

MicrosoftLogin.propTypes = {
  onAuthenticated: PropTypes.func,
  onError: PropTypes.func,
};

export default MicrosoftLogin;



// WEBPACK FOOTER //
// ./client/app/screens/login/azure/MicrosoftLoginButton.jsx